import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AxSelectComponent, AxAutoFocusDirective, AxLabelTemplateDirective, AxOptionTemplateDirective } from './ax-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClient, HttpClientModule } from '@angular/common/http';



@NgModule({
  declarations: [AxSelectComponent, 
    AxAutoFocusDirective,
    AxLabelTemplateDirective, 
    AxOptionTemplateDirective],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule ,
    TooltipModule
  ],
  exports: [AxSelectComponent, AxLabelTemplateDirective, AxOptionTemplateDirective]
})
export class AxSelectModule { }
